<template>
  <div class="group cursor-pointer" @click="$emit('openStore', store)">
    <div class="relative rounded-2xl overflow-hidden aspect-4/3 mb-3 bg-grey-light-200 min-w-[252px] min-h-[252px]">
      <img
        v-if="store.logo"
        :src="store.logo"
        :alt="store.name"
        class="absolute inset-0 w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
      />
      <img
        v-else
        :src="DefaultImage"
        :alt="store.name"
        class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-1/3 object-contain opacity-40"
      />
      <div class="absolute top-3 left-3 right-3 flex justify-between">
        <span
          v-if="currentProduct === 'boost' && rewardLabel"
          class="bg-[#23D59F] text-white text-xs font-semibold px-2.5 py-1 rounded-xl border-white border-[.5px] text-white"
        >
          {{ rewardLabel }}
        </span>
        <span v-else />
        <span
          v-if="store.availability"
          class="bg-white/30 backdrop-blur-md text-white text-xs font-semibold px-2.5 py-1 rounded-xl border-[.5px] border-white"
        >
          {{ store.availability }}
        </span>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <h3 class="font-semibold text-lg text-grey-light-900">{{ store.name }}</h3>
      <span
        v-if="isNewStore(store.createdAt)"
        class="bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-1 rounded-md"
        >New</span
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import DefaultImage from '@/assets/logo.svg';
import { useShopsStore } from '@/stores/shops';
import { displayCurrency } from '@/utils/format.utils';
import { isNewStore } from '@/utils/stores.utils';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import type { ModelMerchantShopDirectoryShopV2 } from '@layup/api-sdk';

const props = defineProps<{
  store: ModelMerchantShopDirectoryShopV2;
}>();

defineEmits<{
  openStore: [store: ModelMerchantShopDirectoryShopV2];
}>();

const { currentProduct } = storeToRefs(useShopsStore());

const rewardLabel = computed(() => {
  const rewards = props.store.boostRewards;
  if (!rewards) return null;
  if (rewards.rewardType === 'FLAT' && rewards.rewardFlatFeeInCents) {
    return `${displayCurrency(rewards.rewardFlatFeeInCents)} Reward`;
  }

  if (rewards.rewardType === 'PERCENTAGE' && rewards.rewardPercentage) {
    return `${rewards.rewardPercentage}% Reward`;
  }

  return null;
});
</script>
